export enum EventDateStatusEnum {
    ON_SALE = 'on_sale',
    OFF_SALE = 'off_sale',
    CANCELLED = 'cancelled'
}